enum JobState {
    Pending = 0,
    Running = 1,
    Stopping = 2,
    Faulted = 3,
    Successful = 4,
    Stopped = 5,
    Retried = 6
}

const JobStateValue = {
    GetText: (typeNumber: number) => {
        return JobState[typeNumber].valueOf()
    }
}

export default JobStateValue